module.exports = __webpack_public_path__ + "static/img/home_foto3_roja.dd5c100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_foto3_roja.png
// module id = 16
// module chunks = 0